import styled from 'styled-components'
import { flexDirection, FlexDirectionProps } from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & GapProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${flexDirection}
  ${gap}
`
